
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#2C7FE1","fill-rule":"evenodd","d":"M10 0C4.477 0 0 4.478 0 10s4.477 10 10 10c5.522 0 10-4.477 10-10S15.522 0 10 0zm0 15.53a1.3 1.3 0 01-1.3-1.3h2.6a1.3 1.3 0 01-1.3 1.3zm4.393-2.603c0 .48-.39.512-.87.512H6.477c-.48 0-.87-.032-.87-.512v-.083c0-.346.204-.642.495-.782l.276-2.384a3.623 3.623 0 012.877-3.545v-.925a.745.745 0 111.49 0v.925a3.622 3.622 0 012.877 3.545l.276 2.384c.292.14.495.436.495.782v.083z"}})])
          )
        }
      }
    